import styled from "@emotion/styled"
import { waTriggerEvent } from "components/analytics/DigitalDataLayer"
import BeautyshotPush from "components/cards/beautyshot-card/BeautyshotCard"
import { useConsole } from "contexts/Console"

const Root = styled.div``

export default function BeautyshotButton({ beautyshot, ...props }) {
  const console = useConsole()

  async function trigger() {
    const pathSegments = window.location.pathname.split("/")
    const name = pathSegments[pathSegments.length - 1].replace(/-/g, " ")

    waTriggerEvent({
      eventName: "editoCardClicked",
      eventType: "Click",
      editoCardInfo: {
        name: beautyshot.rmc,
        url: "",
        category: name,
      },
    })
  }

  console.log("BeautyshotButton(%o)", beautyshot)

  return (
    <Root {...props}>
      <BeautyshotPush {...beautyshot} popin_image_cld={{ sources: beautyshot.asset }} onClick={trigger} />
    </Root>
  )
}
